/** parsePriorityFilters produce a filter object (see example) populated
 * from the given URLSearchParams object. */
export const parseUserAccountFilters = (params /* URLSearchParams */) => ({
  // Filters
  active: params.get("active"),
  id_ctns: params.get("id_ctns"), // id contains this string somewhere
  name_ctns: params.get("name_ctns"), // id contains this string somewhere
  sort_order: params.get("sort_order") || "DESC", // The sort order
  sort_by: params.get("sort_by") || "created_at", // The column to sort by
})

/** parsePriorityFilters produce a filter object (see example) populated
 * from the given URLSearchParams object. */
export const parseAccessLogsFilters = (params /* URLSearchParams */) => ({
  // Filters
  from: params.get("from"), // ISO date/time string, or key for `dateTimeProducer` fn
  to: params.get("to"), // ISO date/time string, or key for `dateTimeProducer` fn
  user_ids: params.get("user_ids"),
  sort_order: params.get("sort_order"), // The sort order
  sort_by: params.get("sort_by"), // The column to sort by
})
